import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/system";

const useStyles = makeStyles((theme: Theme) => ({
  BackgroundStyle: {
    backgroundColor: "#FFFFFF !important",
    minHeight: "100vh",
    padding: "80px 0",
    width: "100%",
    marginTop: 32,
    [theme.breakpoints?.down("sm")]: {
      paddingBottom: 10,
    },
  },
  helpDeskBox: {
    width: "100%",
    height: "104px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    padding: "22px 0",
    borderRadius: 12,
    marginTop: 14,
    [theme.breakpoints?.down("sm")]: {
      paddingTop: 160,
      height: "230px",
      width: "100%",
      textAlign: "center",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right",
      backgroundSize: "780px 180px",
      backgroundColor: "inherit",
    },
  },
  helpDeskButton: {
    cursor: "pointer",
    display: "inline-block",
    maxWidth: "100%",
  },
  breadcrumbsStyle: {
    [theme.breakpoints?.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "nowrap",
      width: "100%",
      marginLeft: 0,
    },
  },
  loadingStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: 235,
  },
  btnToggle: {
    height: "68px",
    border: "1px solid #DEE3ED",
    borderRadius: "5px",
    justifyContent: "flex-start",
    [theme.breakpoints?.down("sm")]: {
      height: "54px",
    },
  },
  btnToggleContent: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "12px",
    marginLeft: 14,
    [theme.breakpoints?.down("sm")]: {
      marginLeft: 0,
    },
  },
  wrapper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
  },
  dialogWhatsapp: {
    top: "unset",
    "& .MuiPaper-root": {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
    },
  },
}));

export default useStyles;
